<app-reports
  title="Patient Verified Prescriptions Reports"
  [reportsUrl]="reportsUrl"
  [reportsCountUrl]="reportsCountUrl" />
